import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AppDownloadBanner from 'src/components/AppDownloadBanner';
import { driver } from 'driver.js';
import { useEffect, useState } from 'react';
import 'driver.js/dist/driver.css';

const SidebarLayout = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const direction = theme.direction || 'ltr';

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',
          direction: direction,
          '.MuiPageTitle-wrapper': {
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05
                  )}`
          }
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            [theme.breakpoints.up('lg')]: {
              mr: direction === 'rtl' ? `${theme.sidebar.width}` : 0,
              ml: direction === 'ltr' ? `${theme.sidebar.width}` : 0
            }
          }}
        >
          <Box display="block">
            <Outlet />
            <AppDownloadBanner />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
